module.exports = __webpack_public_path__ + "media/images/version_merge/scroll_hint_mobile-b9bad37134c923723fbc6caf63aea213.svg";